import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { InviteAlertComponent } from './invite-alert/invite-alert.component';
import { FeaturedPostsComponent } from './featured-posts/featured-posts.component';
import { SharedModule } from '@app/shared/shared.module';
import { AdvertisingModule } from '@app/shared/modules/advertising/advertising.module';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ContentSharedComponentsModule } from '../multimedia/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HomeRoutingModule,
    SharedModule,
    ContentSharedComponentsModule,
    AdvertisingModule
  ],
  declarations: [HomeComponent, InviteAlertComponent, FeaturedPostsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeModule { }
